import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-snapshot-member-loader',
  templateUrl: './snapshot-member-loader.component.html',
  styleUrls: ['./snapshot-member-loader.component.scss']
})
export class SnapshotMemberLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
